/* A2 Bikes - SP Drop signup helpers (pure functions, no DOM side effects at load).
   Used by snippets/a2-restock-alert.liquid (PDP card: buildPayloads, one build) and
   sections/a2l-early-access.liquid (launch page: resolveVariantIds + buildPayloadsMulti, several builds).
   Drop number (o.dropNumber, default 2) names the Klaviyo metric "SP Drop <n> Signup", the profile
   properties "SP Drop <n> Groupset/Color/Size/Early Access" and the CRM source "sp_drop<n>_pdp" /
   "sp_drop<n>_launch_page", so the same code serves Drop #2, Drop #3, ... (number comes from the
   shop metafield custom.sp_drop.number).
   Quick signup (snippets/a2-drop-quick.liquid): buildPayloadsQuick (email only) + buildPickPayloads (optional build step).
   Exposes window.A2Drop = { normalizePhone, mapColor, buildPayloads, resolveVariantIds, buildPayloadsMulti,
   buildPayloadsQuick, buildPickPayloads }. Tests: node --test tests/*.test.js */
(function (root) {
  'use strict';

  /* US mobile -> "+1XXXXXXXXXX", or null when it can't be normalised. */
  function normalizePhone(raw) {
    var d = String(raw == null ? '' : raw).replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return null;
  }

  /* Colours outside the drop's colour list collapse to "Either". */
  function mapColor(picked, allowed) {
    var list = allowed || [];
    if (!picked) return { color: 'Either', mapped: false };
    if (!list.length) return { color: picked, mapped: false };
    for (var i = 0; i < list.length; i++) {
      if (list[i] === picked) return { color: picked, mapped: false };
    }
    return { color: 'Either', mapped: true };
  }

  function copy(src, dst) {
    for (var k in src) { if (Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k]; }
    return dst;
  }

  /* "SP Drop 3 Signup" / "SP Drop 3 Groupset" ... from the drop number (default 2). */
  function dropNames(n) {
    var num = /^\d+$/.test(String(n == null ? '' : n)) ? String(n) : '2';
    var prefix = 'SP Drop ' + num + ' ';
    return { num: num, metric: prefix + 'Signup', groupset: prefix + 'Groupset', color: prefix + 'Color',
      size: prefix + 'Size', early: prefix + 'Early Access' };
  }

  function buildPayloads(o) {
    var N = dropNames(o.dropNumber);
    var sms = !!(o.sms && o.phone);
    var utm = o.utm || {};
    var vid = o.variantId ? String(o.variantId) : '';
    var vids = vid ? [vid] : [];
    var crmVids = /^\d+$/.test(vid) ? [vid] : [];

    // Klaviyo client/subscriptions (revision 2024-10-15) rejects a `subscriptions`
    // object on the profile (400 "not a valid field"). Consent is expressed by the
    // identifiers sent: email subscribes email; phone_number is sent ONLY when the
    // shopper ticked SMS consent, which subscribes SMS.
    var profileAttrs = { email: o.email };
    if (sms) { profileAttrs.phone_number = o.phone; }

    var subscription = { data: { type: 'subscription',
      attributes: { custom_source: o.source, profile: { data: { type: 'profile', attributes: profileAttrs } } },
      relationships: { list: { data: { type: 'list', id: o.list } } } } };

    var props = copy(utm, {
      groupsets: [o.build],
      groupset_handles: [o.handle],
      color: o.color,
      size: o.size,
      variant_ids: vids,
      product_handle: o.handle,
      page_url: o.pageUrl,
      sms_opt_in: sms,
      build: o.build,
      variant: o.variantTitle || '',
      variant_id: vid,
      source: o.source
    });
    var profileProps = {};
    profileProps[N.groupset] = [o.build];
    profileProps[N.color] = o.color;
    profileProps[N.size] = o.size;
    profileProps[N.early] = true;
    var event = { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: N.metric } } },
      profile: { data: { type: 'profile', attributes: {
        email: o.email,
        properties: profileProps } } } } } };

    var crm = {
      email: o.email,
      source: 'sp_drop' + N.num + '_pdp',
      shopify_client_id: o.shopifyClientId || null,
      ga4_client_id: o.ga4ClientId || null,
      drop: {
        drop: o.drop,
        groupsets: [o.handle],
        color: o.color,
        size: o.size,
        variant_ids: crmVids,
        phone: sms ? o.phone : null,
        sms_opt_in: sms,
        utm: utm
      }
    };
    return { subscription: subscription, event: event, crm: crm };
  }

  /* ---------- launch page (several builds) ---------- */

  function key(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  var SIZE_KEYS = { s: 'small', sm: 'small', small: 'small', m: 'medium', md: 'medium', med: 'medium', medium: 'medium',
    l: 'large', lg: 'large', large: 'large', xl: 'xl', xlarge: 'xl', extralarge: 'xl' };
  function sizeKey(s) { var k = key(s); return SIZE_KEYS[k] || k; }

  /* Variant ids (digit strings, deduped, in build order) for the selected builds x colour x size.
     builds = { handle: { colors: [drop colours], variants: [{ id, color (Color option), size (Size option) }] } }.
     color: a drop colour, "Either" or "" -> per build: that colour when the build offers it, otherwise
     all of the build's drop colours (so 105 always resolves to its one colour). No drop colours
     configured -> any colour (or just the picked one when it is specific).
     size: Small|Medium|Large|XL, or "Not sure"/"" -> every size. */
  function resolveVariantIds(builds, handles, color, size) {
    var out = [], seen = {}, map = builds || {};
    var anySize = !size || size === 'Not sure', wantSize = sizeKey(size);
    for (var i = 0; i < (handles || []).length; i++) {
      var b = map[handles[i]];
      if (!b) continue;
      var offered = Object.prototype.toString.call(b.colors) === '[object Array]' ? b.colors : [], want = null;
      var specific = color && color !== 'Either';
      if (specific) {
        for (var j = 0; j < offered.length; j++) { if (key(offered[j]) === key(color)) { want = [color]; break; } }
        if (!want && !offered.length) want = [color];
      }
      if (!want) want = offered.slice();
      var wantKeys = {};
      for (var w = 0; w < want.length; w++) wantKeys[key(want[w])] = 1;
      var vs = b.variants || [];
      for (var v = 0; v < vs.length; v++) {
        var id = String(vs[v].id == null ? '' : vs[v].id);
        if (!/^\d+$/.test(id) || seen[id]) continue;
        if (want.length && !wantKeys[key(vs[v].color)]) continue;
        if (!anySize && sizeKey(vs[v].size) !== wantSize) continue;
        seen[id] = 1; out.push(id);
      }
    }
    return out;
  }

  /* Same three payloads as buildPayloads, for one signup covering several builds.
     o.builds = [{ handle, name }] (name = display name, e.g. "SP Rival AXS"); o.color = the chosen colour,
     "Either", or - when every selected build has a single drop colour (only 105) - that colour
     ("Matte Black"); passed through as-is, the CRM maps colour per build; o.size; o.variantIds = resolveVariantIds(...). Other fields as buildPayloads
     (list, source, email, phone, sms, pageUrl, utm, shopifyClientId, ga4ClientId, drop, dropNumber) plus
     optional o.productHandle (default "launch-page") and o.crmSource (default "sp_drop<n>_launch_page"). */
  function buildPayloadsMulti(o) {
    var N = dropNames(o.dropNumber);
    var sms = !!(o.sms && o.phone);
    var utm = o.utm || {};
    var names = [], handles = [], seenH = {}, list = o.builds || [];
    for (var i = 0; i < list.length; i++) {
      var h = list[i] && list[i].handle ? String(list[i].handle) : '';
      if (!h || seenH[h]) continue;
      seenH[h] = 1; handles.push(h); names.push(String(list[i].name || h));
    }
    var vids = [], seenV = {}, rawV = o.variantIds || [];
    for (var v = 0; v < rawV.length; v++) {
      var id = String(rawV[v]);
      if (/^\d+$/.test(id) && !seenV[id]) { seenV[id] = 1; vids.push(id); }
    }
    var color = o.color == null ? '' : String(o.color);

    // Klaviyo client/subscriptions (revision 2024-10-15) rejects a `subscriptions`
    // object on the profile (400 "not a valid field"). Consent is expressed by the
    // identifiers sent: email subscribes email; phone_number is sent ONLY when the
    // shopper ticked SMS consent, which subscribes SMS.
    var profileAttrs = { email: o.email };
    if (sms) { profileAttrs.phone_number = o.phone; }

    var subscription = { data: { type: 'subscription',
      attributes: { custom_source: o.source, profile: { data: { type: 'profile', attributes: profileAttrs } } },
      relationships: { list: { data: { type: 'list', id: o.list } } } } };

    var props = copy(utm, {
      groupsets: names.slice(),
      groupset_handles: handles.slice(),
      color: color,
      size: o.size,
      variant_ids: vids.slice(),
      product_handle: o.productHandle || 'launch-page',
      page_url: o.pageUrl,
      sms_opt_in: sms,
      build: names.join(' + '),
      source: o.source
    });
    var profileProps = {};
    profileProps[N.groupset] = names.slice();
    profileProps[N.color] = color;
    profileProps[N.size] = o.size;
    profileProps[N.early] = true;
    var event = { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: N.metric } } },
      profile: { data: { type: 'profile', attributes: {
        email: o.email,
        properties: profileProps } } } } } };

    var crm = {
      email: o.email,
      source: o.crmSource || ('sp_drop' + N.num + '_launch_page'),
      shopify_client_id: o.shopifyClientId || null,
      ga4_client_id: o.ga4ClientId || null,
      drop: {
        drop: o.drop,
        groupsets: handles.slice(),
        color: color,
        size: o.size,
        variant_ids: vids.slice(),
        phone: sms ? o.phone : null,
        sms_opt_in: sms,
        utm: utm
      }
    };
    return { subscription: subscription, event: event, crm: crm };
  }

  /* ---------- quick signup (email only, snippets/a2-drop-quick.liquid) ---------- */

  /* Email-only signup: same list + "SP Drop <n> Signup" metric as the full form, size "Not sure", no build.
     The Groupset profile property is NOT sent, so an earlier pick from the full form is never wiped.
     o: list, source, email, pageUrl, utm, shopifyClientId, ga4ClientId, drop, dropNumber,
     placement ("lp_hero" | "home_hero") -> product_handle and CRM source "sp_drop<n>_<placement>". */
  function buildPayloadsQuick(o) {
    var N = dropNames(o.dropNumber);
    var utm = o.utm || {};
    var subscription = { data: { type: 'subscription',
      attributes: { custom_source: o.source, profile: { data: { type: 'profile', attributes: { email: o.email } } } },
      relationships: { list: { data: { type: 'list', id: o.list } } } } };
    var props = copy(utm, {
      groupsets: [], groupset_handles: [], color: '', size: 'Not sure', variant_ids: [],
      product_handle: o.placement, page_url: o.pageUrl, sms_opt_in: false, build: '', source: o.source
    });
    var profileProps = {};
    profileProps[N.early] = true;
    var event = { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: N.metric } } },
      profile: { data: { type: 'profile', attributes: { email: o.email, properties: profileProps } } } } } };
    var crm = {
      email: o.email,
      source: 'sp_drop' + N.num + '_' + o.placement,
      shopify_client_id: o.shopifyClientId || null,
      ga4_client_id: o.ga4ClientId || null,
      drop: { drop: o.drop, groupsets: [], color: '', size: 'Not sure', variant_ids: [], phone: null, sms_opt_in: false, utm: utm }
    };
    return { subscription: subscription, event: event, crm: crm };
  }

  /* Optional step 2 after a quick signup: "SP Drop <n> Build Picked" (a separate metric, so the
     signup confirmation flow never fires twice) setting the "SP Drop <n> Groupset" profile property
     the build segments read. o.builds = [{ handle, name, colors }]; o.notSure = true -> event only
     (no Groupset, crm null). CRM colour: the sole colour when every build has one (105), else "Either". */
  function buildPickPayloads(o) {
    var N = dropNames(o.dropNumber);
    var utm = o.utm || {};
    var notSure = !!o.notSure;
    var names = [], handles = [], single = {}, nSingle = 0, multi = false, list = notSure ? [] : (o.builds || []);
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (!b || !b.handle) continue;
      handles.push(String(b.handle)); names.push(String(b.name || b.handle));
      var c = b.colors || [];
      if (c.length === 1) { if (!single[c[0]]) { single[c[0]] = 1; nSingle++; } } else { multi = true; }
    }
    var profileProps = {};
    if (!notSure) { profileProps[N.groupset] = names.slice(); }
    var event = { data: { type: 'event', attributes: {
      properties: copy(utm, { groupsets: names.slice(), groupset_handles: handles.slice(), not_sure: notSure,
        product_handle: o.placement, page_url: o.pageUrl }),
      metric: { data: { type: 'metric', attributes: { name: 'SP Drop ' + N.num + ' Build Picked' } } },
      profile: { data: { type: 'profile', attributes: { email: o.email, properties: profileProps } } } } } };
    var color = 'Either';
    if (!multi && nSingle === 1) { for (var k in single) { color = k; } }
    var crm = notSure || !handles.length ? null : {
      email: o.email,
      source: 'sp_drop' + N.num + '_' + o.placement + '_pick',
      shopify_client_id: o.shopifyClientId || null,
      ga4_client_id: o.ga4ClientId || null,
      drop: { drop: o.drop, groupsets: handles.slice(), color: color, size: 'Not sure', variant_ids: [], phone: null, sms_opt_in: false, utm: utm }
    };
    return { event: event, crm: crm };
  }

  root.A2Drop = { normalizePhone: normalizePhone, mapColor: mapColor, buildPayloads: buildPayloads,
    resolveVariantIds: resolveVariantIds, buildPayloadsMulti: buildPayloadsMulti,
    buildPayloadsQuick: buildPayloadsQuick, buildPickPayloads: buildPickPayloads };
})(typeof window !== 'undefined' ? window : this);
